import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useMemo, useState } from "react";
import TransactionModal from "./TransactionModal";
import { Chip, Button } from "@mui/material";
import { useParams } from "react-router-dom";
import { getImportTransactions, uploadImport } from "./api";

export default function ImportPage() {
  const { id } = useParams();

  const [transactions, setTransactions] = useState([]);

  const fetchImportTransactions = async () => {
    const rows = await getImportTransactions(id);
    setTransactions(rows);
  }
  // ---------------------------
  // load transactions
  // ---------------------------
  useEffect(() => {
    if (!id) return;
    fetchImportTransactions();
  }, [id]);

  
  // ---------------------------
  // upload xml
  // ---------------------------
  const uploadXML = async (e) => {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("file", file);

    const data = await uploadImport(formData);
    setTransactions(data);
  };


  // ---------------------------
  // build rows for grid
  // ---------------------------
  const rows = useMemo(() => {
    return (transactions ?? []).map(tx => ({
      id: tx.id,
      ...tx,
    }));
  }, [transactions]);

  // ---------------------------
  // columns
  // ---------------------------
  const columns = [
    { field: "bank_ref", headerName: "Bank Ref", width: 180 },

    { field: "name", headerName: "Name", width: 180 },

    { field: "iban", headerName: "IBAN", width: 180 },

    { field: "description", headerName: "Description", width: 220 },

    {
      field: "direction",
      headerName: "Direction",
      width: 110,
      renderCell: p => (
        <div>{p.value === "DBIT" ? "Debit" : "Credit"}</div>
      )
    },

    {
      field: "amount",
      headerName: "Amount",
      width: 130,
      renderCell: p => (
        <div>
          {p.row.currency} {p.value?.toFixed(2)}
        </div>
      )
    },

    { field: "date", headerName: "Date", width: 140 },

  ];


  return (
    <div>

      <input type="file" accept=".xml" onChange={uploadXML} />
      
      {rows.length > 0 ? (
      <>
        <h2>Review Bank Transactions</h2>

        <DataGrid
          disableRowSelectionOnClick
          rows={rows}
          columns={columns}
          getRowId={r => r.id}
        />

        <Button variant="contained" href={"/imports"}>
          Back
        </Button>
      </>
      ) : (
        <p>No transactions loaded. Please upload an XML file.</p>
      )}
    </div>
  );
}
